export const contentSearchService = {
  search: () => []
};
